// Fetches Entra profile photos via Microsoft Graph.
// Requires User.ReadBasic.All scope (admin consent) to look up other users.
// Falls back to null gracefully — callers should render initials avatars.

/** Fetch the signed-in user's own photo. Requires User.Read (already in scope). */
export async function fetchMyPhoto(accessToken: string): Promise<string | null> {
  return fetchPhotoByPath(accessToken, "me");
}

/** Fetch any user's photo by their email / UPN. Requires User.ReadBasic.All. */
export async function fetchUserPhoto(accessToken: string, email: string): Promise<string | null> {
  if (!email) return null;
  return fetchPhotoByPath(accessToken, `users/${encodeURIComponent(email)}`);
}

async function fetchPhotoByPath(accessToken: string, userPath: string): Promise<string | null> {
  try {
    const res = await fetch(
      `https://graph.microsoft.com/v1.0/${userPath}/photo/$value`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    if (!res.ok) return null;
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}
